import React, { Component } from 'react';
import Config from './Config';
import FX from './functions/functions';

class ProductSetSelector extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {list : this.props.root.state.current_customer.product_sets, minimised: true};
  }
  createProductSet = () =>
  {
     var xhr = new XMLHttpRequest();
     xhr.onreadystatechange = () => {
      var DONE = 4; // readyState 4 means the request is done.
      var OK = 200; // status 200 is a successful return.
      if (xhr.readyState === DONE) {
        if (parseInt(xhr.status, 10) === OK) 
            this.props.root.setState({waiting: false});
            try{
              var ps = JSON.parse(xhr.responseText);
              var cc = this.props.root.state.current_customer;
              cc.product_set = ps;
              this.props.root.setState({current_customer : cc});
              document.getElementById('newProductSet').style.display = '';
            }
            catch(e) {
              console.log(e);
              console.log(xhr.responseText);
            }
        } else if (xhr.status) {
      }
    };
    if(localStorage.token){
      xhr.open('POST', Config.apiHost + '/ProductSet');
      xhr.setRequestHeader("X-Token-Sec", localStorage.token);
      xhr.send(JSON.stringify({productSetName:document.getElementById('productSetName').value, customer_id:this.props.root.state.current_customer.id,}));
      this.props.root.setState({waiting: true, blockChange: false});
    }
  }
  showCreateProductSet = () =>
  {
    document.getElementById('newProductSet').style.display = 'block';
    document.getElementById('productSetName').value = '';
  }
  hideCreateProductSet = () =>
  {
    document.getElementById('newProductSet').style.display = '';
    document.getElementById('productSetName').value = '';
  }
  minimise = () => {
    this.setState({minimised : !this.state.minimised});
  }
  deleteProdSet = (psid,e) => {
    e.preventDefault();
    e.stopPropagation();
    if(!window.confirm('Do you wish to delete this product set?')){
      return false;
    }
     var xhr = new XMLHttpRequest();
     xhr.onreadystatechange = () => {
      var DONE = 4; // readyState 4 means the request is done.
      var OK = 200; // status 200 is a successful return.
      if (xhr.readyState === DONE) {
        if (parseInt(xhr.status, 10) === OK) 
            this.props.root.setState({waiting: false});
            try{
              var ps = JSON.parse(xhr.responseText);
              var cc = this.props.root.state.current_customer;
              cc.product_set = ps;
              this.props.root.setState({current_customer : cc});
              document.getElementById('newProductSet').style.display = '';
            }
            catch(e) {
              console.log(e);
              console.log(xhr.responseText);
            }
        } else if (xhr.status) {
      }
    };
    if(localStorage.token){
      xhr.open('DELETE', Config.apiHost + '/ProductSet');
      xhr.setRequestHeader("X-Token-Sec", localStorage.token);
      xhr.send(JSON.stringify({productSet:psid,productSetName:'', customer_id:this.props.root.state.current_customer.id}));
      this.props.root.setState({waiting: true, blockChange: false});
    }
  }
  render() {
        var bulk  = '';
        var actionDesc = ''; 
        if(this.props.bulkList.length && this.props._parent.state.product_set == null){
          bulk =( 
          <div className="actionBar">
            Choose Product Set
          </div>
           )
        }
        else if(this.props.bulkList.length && this.props._parent.state.product_set != null){
          bulk =(
            <div className="actionBar">
              <button onClick={this.props._parent.removeFromProductSet.bind(this,this.props._parent.state.product_set.id)}>Remove from Product Set "{this.props._parent.state.product_set.name}"?</button>
            </div>
          )
        }
       var sets = this.props.root.state.current_customer.product_set.map((prodSet) => {
       var classes;
       var deller;
       classes = 'ProductSet'; 
       if (this.props.bulkList.length){
        classes += ' target';
       }
       if (this.props._parent.state.product_set != null  && this.props._parent.state.product_set.id === prodSet.id){
        classes += ' active';
        deller = <div className="deller" onClick={this.deleteProdSet.bind(this, prodSet.id)}>X</div>;
       }
       return (
        <div onClick={this.props._parent.setProductSet.bind(this.props._parent, prodSet)} className={classes} key={prodSet.id}>
          <span>{prodSet.name}</span>
          {deller}
        </div>
       );
		  });
		  var className="ProductSetSelector";
		  if(this.state.minimised && !this.props.bulkList.length){
		    className +=" minimised";
		  }
    return (<div className={className}>
              <img id="handle" onClick={this.minimise} src="/images/grab_it.png" />
            <h2 onClick={this.minimise}>Product Sets</h2>
            {bulk}
            <div className="slots">
            <div onClick={this.props._parent.setProductSet.bind(this.props._parent, null)} className='ProductSet'>View All</div>
              {sets}
              <button className="addProductSet" onClick={this.showCreateProductSet}>+</button>
              <div id="newProductSet">
              <div className="island">
              <h1>Create New Product Set</h1>
              <h3>Product set name</h3>
              <input id="productSetName" />
              <button className="create" onClick={this.createProductSet}>Create</button>
              <button className="closeBtn" onClick={this.hideCreateProductSet}>Close</button>
              </div>
              </div>
              </div>
            </div>);
  }
}

export default ProductSetSelector;



// WEBPACK FOOTER //
// ./src/ProductSetSelector.js